module.exports = __webpack_public_path__ + "static/media/bg-bottom-light-green.d40266d3.png";